import {
  IAffiliateCtaFields,
  IRegistrationEntrypointFields
} from '../../../types/contentful';

import { ButtonColorTokenProp } from '../../theme/tokens/button-color';
import { CFColorTokenProp } from '../../theme/tokens/contentful-color';

export const DEFAULT_LABEL_V1 = 'Enter mobile phone number';
export const DEFAULT_PLACEHOLDER_V1 = 'Enter mobile number';
export const DEFAULT_BUTTON_TEXT_V1 = 'Get Started';

export const DEFAULT_LABEL = 'Enter Mobile Phone Number';
export const DEFAULT_PLACEHOLDER = 'Enter Mobile Number';
export const DEFAULT_BUTTON_TEXT = 'Get Started';

export const DEFAULT_EMAIL_LABEL = 'Enter email address';
export const DEFAULT_EMAIL_BUTTON_TEXT = 'Notify Me';
export const VALID_EMAIL =
  'We will let you know when the app is up and running';
export const DEFAULT_EMAIL_WIDGET_BUTTON_TEXT = 'Submit';
export const SUBMITTED_TEXT = 'Submitted!';
export const THANKS_TEXT_WITH_SPACING =
  '\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0Thank you!';
export const THANKS_TEXT = 'Thank you!';

export enum ctaWidgetEnum {
  GET_STARTED = 'Get Started Button',
  GET_STARTED_NO_PHONE = 'Get Started - No Phone',
  GET_STARTED_V1 = '1.0 Get Started',
  MOBILE_PHONE_NUMBER = 'Button Inside Phone Number',
  DESKTOP_PHONE_NUMBER = 'Button Next To Phone Number',
  DESKTOP_PHONE_NUMBER_V1 = '1.0 Button Overlapping Phone Number',
  INBLOCK_PHONE_NUMBER_V1 = '1.0 In Block Phone Number',
  WAITLIST_EMAIL_CAPTURE = 'Waitlist Email Capture'
}

export interface RegistrationEntrypoint
  extends Partial<
    Omit<
      IRegistrationEntrypointFields,
      'designType' | 'buttonColor' | 'buttonHoverColor' | 'buttonText'
    >
  > {
  sysId?: string;
  designType?: ctaWidgetEnum | IRegistrationEntrypointFields['designType'];
  buttonText?: JSX.Element | string;
  buttonColor?: ButtonColorTokenProp | CFColorTokenProp;
  buttonHoverColor?: ButtonColorTokenProp | CFColorTokenProp;
  buttonContent?: JSX.Element | string;
}

export type PartialCtaProps = RegistrationEntrypoint &
  Partial<IAffiliateCtaFields> &
  Partial<SharedProps>;

export interface InputProps {
  id?: string;
  type: 'tel';
  className: string;
  placeholder?: string;
  label?: string;
  options: {
    delimiters: ['(', ')', ' ', '-'];
    blocks: [0, 3, 0, 3, 4];
    numericOnly: true;
    phoneRegionCode: 'US';
  };
  onChange: (val: string) => void;
  inputMode: 'numeric';
  pattern: '[0-9]*';
  value: string;
  'aria-invalid': boolean;
}

export interface SharedProps {
  id?: string;
  className?: string;
  errorPosition?: string;
  showErrorBanner?: boolean;
  placeholderText?: string;
  labelText?: string;
  sendConsentEvent?: boolean;
}

export interface WidgetProps extends Partial<IRegistrationEntrypointFields> {
  inputProps?: InputProps;
  isScrolled?: boolean;
  buttonContent?: JSX.Element | string;
  setErrorMessage?: Function;
}

export interface NonContentfulWidgetProps extends SharedProps {
  buttonContent?: JSX.Element | string;
  buttonText?: JSX.Element | string;
  buttonColor?: ButtonColorTokenProp | CFColorTokenProp;
  buttonHoverColor?: ButtonColorTokenProp | CFColorTokenProp;
  cfButtonColor?: CFColorTokenProp;
  cfButtonHoverColor?: CFColorTokenProp;
}

export interface WaitlistEmailCaptureProps
  extends Partial<IRegistrationEntrypointFields> {
  id?: string;
  returningUserButtonText?: string;
  setErrorMessage?: Function;
}
